<template>
  <v-card
    v-if="notifications.length"
    class="notification-container"
    elevation="6"
  >
    <NotificationBar
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
    />
  </v-card>
</template>

<script>
import NotificationBar from "@/components/NotificationBar.vue";
import { mapState } from "vuex";

export default {
  components: {
    NotificationBar
  },
  computed: mapState("notification", ["notifications"])
};
</script>

<style lang="scss">
.notification-container {
  position: fixed !important;
  z-index: 1000;
  top: 16px;
  right: 16px;

  .v-alert {
    margin-bottom: 0;
  }
}
</style>
